/**
 * Environment variable validation
 *
 * Validates required environment variables at app startup.
 * Fails fast if required variables are missing.
 */

function validateEnv() {
  const required = {
    VITE_SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL,
    VITE_SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY,
  }

  const missing = []

  for (const [key, value] of Object.entries(required)) {
    if (!value) {
      missing.push(key)
    }
  }

  if (missing.length > 0) {
    throw new Error(
      `Missing required environment variables:\n${missing.map(k => `  - ${k}`).join('\n')}\n\n` +
      'Please check your .env file and ensure all required variables are set.'
    )
  }

  // Validate URL format
  try {
    new URL(required.VITE_SUPABASE_URL)
  } catch (err) {
    throw new Error(`Invalid VITE_SUPABASE_URL: ${required.VITE_SUPABASE_URL}`)
  }

  return required
}

// Validate immediately on import
export const env = validateEnv()
